import type { User } from '@auth0/auth0-react';

export const getUserDisplayName = (user: User | undefined): string => {
  if (!user) {
    return 'User';
  }

  if (user.given_name && user.family_name) {
    return `${user.given_name} ${user.family_name}`;
  }

  if (user.given_name) {
    return user.given_name;
  }

  return user.name ?? 'User';
};
